import { render, staticRenderFns } from "./TopCenters.vue?vue&type=template&id=2d202ed6&scoped=true"
import script from "./TopCenters.vue?vue&type=script&lang=js"
export * from "./TopCenters.vue?vue&type=script&lang=js"
import style0 from "./TopCenters.vue?vue&type=style&index=0&id=2d202ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d202ed6",
  null
  
)

export default component.exports